import { app } from '../../../../../app';
import { Controller } from './account-details.controller';

app.component('companyUserDirectoriesManageAccountDetails', {
    bindings: {
        account: '<',
        companyId: '<',
    },
    controller: Controller,
    templateUrl: require('./account-details.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/manage-account/details/account-details.component.js